import { Linkedin, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { DLMark } from "../shared/Brand";

// Footer
export const Footer = () => (
  <footer className="py-10 sm:py-16 bg-[#0A0A0A] border-t border-white/5">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
      <div className="flex flex-col sm:flex-row justify-between items-center gap-6 sm:gap-8">
        <Link to="/" className="flex items-center gap-2 sm:gap-3 hover:opacity-90 transition-opacity">
          <DLMark size={32} />
          <div>
            <span className="block text-base sm:text-lg font-bold text-white">Dan Leitner</span>
            <span className="block text-[10px] text-zinc-400 tracking-widest uppercase">Leitner Revenue Systems</span>
          </div>
        </Link>
        
        {/* Footer Links */}
        <div className="flex items-center gap-4 sm:gap-6 text-sm text-zinc-400">
          <Link to="/insights" className="hover:text-[#D4AF37] transition-colors">
            Insights
          </Link>
          <Link to="/resources" className="hover:text-[#D4AF37] transition-colors">
            Resources
          </Link>
        </div>
        
        <div className="flex items-center gap-5 sm:gap-6">
          <a 
            href="mailto:dleit1229@gmail.com"
            className="text-zinc-400 hover:text-[#D4AF37] transition-colors p-2"
          >
            <Mail className="w-5 h-5" />
          </a>
          <a 
            href="https://www.linkedin.com/company/leitner-revenue-systems-llc/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-zinc-400 hover:text-[#D4AF37] transition-colors p-2"
          >
            <Linkedin className="w-5 h-5" />
          </a>
        </div>
      </div>
      
      <div className="mt-8 sm:mt-10 pt-6 sm:pt-8 border-t border-white/5 text-center">
        <p className="text-xs sm:text-sm text-zinc-400">
          &copy; {new Date().getFullYear()} Leitner Revenue Systems LLC. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
